module.exports = __webpack_public_path__ + "media/react/features/overview/suggestions/icons/kahoot-icon-5b5098456e7c9f674ba6eb79018c3da9.png";